import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { scaleMenuAnimationOpen } from '../../styles/AnimationOpenClose';
import { getZIndexByLayerName, LayerNames } from '../../../constants/layers.constants';

const ReactSelectMenu = components.Menu;

const Menu = ({
    innerProps,
    isAnimated,
    position,
    transformOrigin,
    width,
}) => (
    <AnimatedMenu
        isAnimated={isAnimated}
        isVisible={innerProps.selectProps.menuIsOpen}
        position={position}
        transformOrigin={transformOrigin}
        width={width}
    >
        <ReactSelectMenu
            {...innerProps}
        />
    </AnimatedMenu>
);

const AnimatedMenu = styled.div`
  animation: ${({ isAnimated }) => (isAnimated ? scaleMenuAnimationOpen : '')}  150ms;
  position: absolute;
  width: ${({ width }) => width};
  display: block;
  z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_3)};
  left: ${({ position }) => position.left};
  bottom: ${({ position }) => position.bottom};
  right: ${({ position }) => position.right};
  top: ${({ position }) => position.top};
  transform-origin: ${({ transformOrigin }) => transformOrigin};
  
`;

Menu.defaultProps = {
    transformOrigin: 'left top',
    position: {
        left: 0,
        top: 'auto',
        bottom: '100%',
        right: 'auto',
    },
    width: '100%',
    isAnimated: true,
};

export default Menu;
